import React from "react";
import { AddCircle as AddCircleIcon, Print as PrintIcon, Forward as GobackIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useHistory } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import BreadcrumbsGenerator from "./BreadcrumbsGenerator";
import { useTranslation } from "react-i18next";
const TitleBox = ({
  title = "",
  subTitle = "",
  addAction = null,
  allowPrint = true,
  addButtonLable = "Add new",
  printButtonLabel = "Print",
  allowGoBack = false,
  setSearchState = null,
  setCurrentPage = null,
  isLoading = false,
  breadcrumbLinks = [],
  customLabels = {}
}) => {
  const {
    t
  } = useTranslation("operations");
  const history = useHistory();
  let timeoutId;
  const handleSearchChange = e => {
    clearTimeout(timeoutId);
    const searchQuery = e.target.value;

    // Set a new timeout
    timeoutId = setTimeout(() => {
      // Call the API after the user has stopped typing for 1000ms
      setCurrentPage(1);
      setSearchState(searchQuery);
    }, 1000); // Adjust the debounce time as necessary
  };
  return <>
      <div className="printOnly printTitle" style={{
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto"
    }}>
        <p>&nbsp;</p>
        {title && <p>{title}</p>}
        {subTitle && <p>{subTitle}</p>}
        <p>{t("date") + ": " + new Date().toLocaleDateString()} </p>
      </div>
      <div className="titleBox np">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <BreadcrumbsGenerator breadcrumbLinks={breadcrumbLinks} customLabels={customLabels} />
          </Grid>
          <Grid item xs={12} md={4}>
            <div style={{
            display: "inline-block",
            marginLeft: "10px",
            marginRight: "10px"
          }}>
              {title}
            </div>
            {addAction && <IconButton aria-label={addButtonLable} onClick={addAction}>
                <AddCircleIcon style={{
              color: "#ffffff",
              fontSize: "30px",
              marginLeft: "10px",
              marginRight: "10px"
            }} />
              </IconButton>}

            {allowPrint && <IconButton aria-label={printButtonLabel} onClick={() => {
            window.print();
          }}>
                <PrintIcon style={{
              color: "#ffffff",
              fontSize: "30px",
              marginLeft: "10px",
              marginRight: "10px"
            }} />
              </IconButton>}
            {allowGoBack && <IconButton aria-label={printButtonLabel} onClick={() => {
            history.goBack();
          }}>
                <GobackIcon style={{
              color: "#ffffff",
              fontSize: "30px",
              transform: "rotate(180deg)",
              marginLeft: "10px",
              marginRight: "10px"
            }} />
              </IconButton>}
            {setSearchState && <>
                <TextField id="input-with-icon-textfield" size="small" placeholder={t("Search")} onChange={handleSearchChange} InputProps={{
              endAdornment: <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
            }} style={{
              width: "200px",
              borderRadius: "10px",
              backgroundColor: "#ffffff",
              verticalAlign: "middle"
            }} />
              </>}
            {subTitle && <p>{subTitle}</p>}
          </Grid>
          <Grid item xs={12} md={4}>
            {isLoading && <CircularProgress />}
          </Grid>
        </Grid>
      </div>
    </>;
};
export default TitleBox;
